import React, {FC, useState} from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {ArrowDown, Icon} from '@optimaxdev/icons';
import classNames from 'classnames';
import AnimateHeight from 'react-animate-height';

import {QuoteItemV2} from 'api/magento/magentoAPI.schemas';
import {BaseGlassesProductItem} from 'components/baseProductItems/baseGlassesProductItem/baseGlassesProductItem';
import {ProductName} from 'components/baseProductItems/productName/productName';
import {CHECKOUT_ORDER_SUMMARY} from 'constants/analytics/events/checkout';

import {CheckoutItemType} from 'desktop/types/checkoutItemsType';

import {GlassesCartItemDetails} from '../../glassesCartItemDetails/glassesCartItemDetails';

import s from './glassesProductItem.scss';

export type PropsType = {
    item: CheckoutItemType;
};

/**
 * Product Item facelift for checkout page
 */
export const GlassesProductItem: FC<PropsType> = ({item}) => {
    const [isOpened, setIsOpened] = useState(false);

    const handleMoreDetailsClick = () => {
        setIsOpened(!isOpened);
        const eventLabel = isOpened ? 'Collapse' : 'Expand';
        sendDesktopAnalyticsEvent(CHECKOUT_ORDER_SUMMARY, {
            label: `More Details - ${eventLabel}`,
        });
    };

    return (
        <div className={s.cartItem}>
            <BaseGlassesProductItem
                nameComponent={
                    <ProductName
                        id={item.id}
                        isCartPage={false}
                        sku={item.product.sku}
                        windowName={item.windowName}
                    />
                }
                item={item as unknown as QuoteItemV2}
            >
                {item.qty > 1 && <span className={s.quantity}>Qty: {item.qty}</span>}
                <button
                    aria-label="More Details"
                    className={s.moreDetailsBtn}
                    onClick={() => handleMoreDetailsClick()}
                    type="button"
                >
                    <span className={s.moreDetailsTitle}>More Details</span>
                    <Icon
                        className={classNames(s.arrow, {
                            [s.iconActive]: isOpened,
                        })}
                        height={6}
                        icon={ArrowDown}
                        strokeWidth={2}
                        width={10}
                    />
                </button>
            </BaseGlassesProductItem>
            <AnimateHeight duration={300} height={isOpened ? 'auto' : 0}>
                <GlassesCartItemDetails item={item} />
            </AnimateHeight>
        </div>
    );
};
